export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BreadCrumbs.vue?vue&type=template&id=51079060&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BreadCrumbs.vue?vue&type=template&id=51079060&scoped=true
// module id = 131
// module chunks = 0